"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var CategoryBanner = function (_a) {
    var title = _a.title, _b = _a.category, category = _b === void 0 ? '' : _b;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var bannerConfig = (0, swr_hooks_1.usePromoBannerConfig)(swr_hooks_1.TEXT_KEYS.CATEGORY_BANNER);
    var isMobile = Object.keys(breakpoints).length > 0 && breakpoints.mobile;
    var containerStyle = (0, swr_hooks_1.getPromoBannerBackgroundStyle)(bannerConfig, isMobile);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(category ? styles_module_scss_1.default[category] : ''), style: containerStyle },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.titleContainer },
            react_1.default.createElement("h1", { className: styles_module_scss_1.default.title }, title))));
};
exports.default = CategoryBanner;
